<template>
  <div>
    <h3 class="my-4">遊台灣學英語 功能清單</h3>
    <div class="my-5 list-box" style="min-height:40vh">
      <!-- <div class="menu-box">
        <p>開始上課</p>
        <p>Start a new course</p>
      </div> -->
      <div class="menu-box" @click="goPage('Record.classList.tw')">
        <p>觀看使用紀錄</p>
        <p>Using a record</p>
      </div>
    </div>
    <div class="download-box px-4">
      <a class="downloadLink" download="LiveCampus 使用手冊" :href="sampleFile">下載使用說明</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {

  name: 'TWIndex',

  data () {
    return {
      sampleFile: require('../../../assets/files/LiveCampus 雲端版線上學習.pdf')
    }
  },
  mounted () {
  },
  computed: {
    roleName () {
      return this.$store.state.auth.user.rolename
    },
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    goPage (link, id) {
      if (this.roleName === 'Teacher') {
        this.$router.push({name: link, params: {id: id, mode: 'App'}})
      } else {
        console.log(this.roleName)
        this.$router.push({name: 'Record.personal.tw', params: {class: '7206214b-46c9-4048-bbd9-f8418786c49d', student: this.user.id}})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/color.scss";
  .list-box {
    width: 60%;
    margin: auto;
  }
  .menu-box {
    cursor: pointer;
    text-align: left;
    background-color: #fff;
    border-radius: 10px;
    border: 1.5px solid #6666;
    margin: 10px auto;
    padding: 10px 20px;
    p {
      margin: 0;
    }
      &:hover {
      box-shadow:0px 0px 8px #a1a1a1;
    }
  }
  .download-box {
    text-align: left;
    .downloadLink {
      font-size: 1.5rem;
    }
  }
</style>


// WEBPACK FOOTER //
// TwIndex.vue?6c2b83a1